import { userDate } from 'owa-datetime/lib/userDate';
import BodyType from './BodyType';
import LinkedEntity, { EMAIL_ENTITY_TYPE } from '../store/schema/LinkedEntity';
import TaskImportance from '../store/schema/TaskImportance';
import TaskStatus from '../store/schema/TaskStatus';
import Todo from '../store/schema/Todo';

export interface DateWithTimeZone {
    DateTime: string;
    TimeZone: string;
}

export default interface Task {
    Id: string;
    ParentFolderId: string;
    Subject: string;
    IsReminderOn: boolean;
    ReminderDateTime: DateWithTimeZone;
    OrderDateTime: string;
    Importance: TaskImportance;
    CompletedDateTime: DateWithTimeZone;
    DueDateTime: DateWithTimeZone;
    Status: TaskStatus;
    Body: BodyType;
    LinkedEntities: [LinkedEntity];
    LinkedEntity: LinkedEntity; // used for setting a linked entity on the task.
}

export function toTodo(taskItem: Task): Todo {
    let todoItem = {
        ...taskItem,
        ReminderDateTime: taskItem.ReminderDateTime
            ? userDate(taskItem.ReminderDateTime.DateTime)
            : undefined,
        CompletedDateTime: taskItem.CompletedDateTime
            ? userDate(taskItem.CompletedDateTime.DateTime)
            : undefined,
        DueDateTime: taskItem.DueDateTime ? userDate(taskItem.DueDateTime.DateTime) : undefined,
        OrderDateTime: taskItem.OrderDateTime ? userDate(taskItem.OrderDateTime) : undefined,
        Status: taskItem.Status as TaskStatus,
        Importance: taskItem.Importance as TaskImportance,
        Note:
            taskItem.Body && taskItem.Body.Content && taskItem.Body.ContentType == 'Text'
                ? taskItem.Body.Content
                : undefined,
        LinkedEmail: getLinkedEmailEntity(taskItem.LinkedEntities),
    } as Todo;

    return taskItem ? todoItem : null;
}

function getLinkedEmailEntity(linkedEntities: [LinkedEntity]): LinkedEntity {
    if (!linkedEntities) {
        return null;
    }

    const emailEntities = linkedEntities.filter(entity => entity.EntityType == EMAIL_ENTITY_TYPE);
    return emailEntities.length == 0 ? null : emailEntities[0];
}
